module.exports = __webpack_public_path__ + "static/media/inetcpl_1311.5522d174.ico";